import React from 'react';
import correct from '../../assets/Logo/correct.png';
import incorrect from '../../assets/Logo/incorrect.png';

const PasswordValidator = ({ password }) => {
    const validationRules = [
        {
            type: 'less',
            pattern: /^.{8,}$/,
            message: '8 characters minimum',
        },
        {
            type: 'upper',
            pattern: /^(?=.*[A-Z])/,
            message: 'one uppercase letter',
        },
        {
            type: 'lower',
            pattern: /^(?=.*[a-z])/,
            message: 'one lowercase letter',
        },
        {
            type: 'number',
            pattern: /^(?=.*[0-9])/,
            message: 'one number',
        },
        {
            type: 'specialC',
            pattern: /^(?=.*[!@#$%^&*()_+{}[\]:;<>,.?~\\/-])/,
            message: 'one special character',
        },
    ];
    return (
        <div>
            <div className='mt-4 justify-start items-center flex-wrap gap-4 flex'>
                {validationRules.map((rule) => (
                    <span
                        key={rule.type}
                        className={`${rule.pattern.test(password) ? 'text-[#21893c]' : 'text-[#e53e3b]'
                            } transition-all duration-200 sm:text-[15px] text-[13px] font-bold flex items-center gap-x-2`}
                    >
                        {rule.pattern.test(password) ? (
                            <img
                                src={correct}
                                alt=''
                                className='w-[0.9rem]'
                                loading='lazy'
                            />
                        ) : (
                            <img
                                src={incorrect}
                                alt=''
                                className='w-[0.9rem]'
                                loading='lazy'
                            />
                        )}
                        {rule.message}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default PasswordValidator;